import { useDispatch } from 'react-redux';
import { toogleToast } from 'reducers/misc';

export function useToast(message: string) {
  const dispatch = useDispatch();
  const windowGlobal = typeof window !== 'undefined';

  return () => {
    dispatch(toogleToast({ open: true, message: message }));

    windowGlobal &&
      window.setTimeout(() => {
        dispatch(toogleToast({ open: true, message: '' }));
      }, 3500);

    windowGlobal &&
      window.setTimeout(() => {
        dispatch(toogleToast({ open: false, message: '' }));
      }, 3600);
  };
}
